import {makeStyles} from "@material-ui/core/styles";
import {useDispatch, useSelector} from "../../store";
import React, {useEffect, useState} from "react";
import {withExplorer} from "../../layout/Explorer";
import clsx from "clsx";
import Box from "../../lib/appfuse-react/component/Box";
import i18n from "../../lib/appfuse-react/core/i18n";
import usePrompt from "../../lib/appfuse-react/hook/usePrompt";
import {
    selectRegion,
    selectRegistrationForm,
    setRegistrationForm
} from "../../reducer/iam/registrationReducer";
import useRouter from "../../lib/appfuse-react/hook/useRouter";
import {HomeImage} from "../Home";
import Paper from "../../lib/appfuse-react/component/Paper";
import DomesticRegistration, {DomesticStepper} from "./DomesticRegistration";
import utilService from "../../service/util/utilService";
import {setCounty} from "../../reducer/util/utilReducer";
import code from "../../lib/appfuse-react/core/code";
import OverseasRegistration, {OverseasStepper} from "./OverseasRegistration";
import RegistrationMain, {StartStepper} from "./RegistrationMain";

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        width: '100%',
        height: '100%',
    },
    workspace: {
        position: 'absolute',
        top: '10%',
        display: 'flex',
        justifyContent: 'center',
        width: '90%',
        left: '5%',
        right: "5%",
        gap: '1rem',
        height: '80%',
    },
    form: {
        width: '100%',
       // maxWidth: '32rem',
        minWidth: '40%',
        padding: theme.spacing(2,3,2,3),
        display: 'flex',
        flexDirection: 'column',
        gap: `${theme.spacing(2)}px`,
        maxHeight: '100%',
        overflow: "hidden",
    },
    stepper: {
        width: '25%',
    },
    transparent: {
        opacity: 0.95,
        filter: 'drop-shadow(12px 12px 7px rgba(0, 0, 0, 0.7))',
    },
    buttons: {
        '& > *:not(:first-child)': {
            marginLeft: theme.spacing(1)
        },
        height: '100%'
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    link: {
        textDecoration: 'underline',
        textUnderlinePosition: 'under',
        cursor: 'pointer'
    },
}));

/**
 * 註冊
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

function Registration(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const router = useRouter();
    const prompt = usePrompt();
    const value = useSelector(selectRegistrationForm);
    const [registerStep, setRegisterStep] = useState(0);
    const [activeStep, setActiveStep] = useState(0);
    const [region, setRegion] = useState(null);

    useEffect(() => {
        (async () => {
            await code.assert('processingLegalStatus', 'certificate', 'certificationStandard', 'processingBusinessType', 'identityType');

            const county = await utilService.findCounty();
            dispatch(setCounty(county));
        })()
    },[])

    const handleChange = (event) => {
        dispatch(setRegistrationForm(event.value));
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        // 回到註冊首頁將資料清掉
        if(activeStep -1 === 0) dispatch(setRegistrationForm({}));

        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleRegion = (event) => {
        const {value} = event;
        if(registerStep===1) {
            setRegion((prevRegion) => {
                if(prevRegion===value){
                    setRegisterStep((prevRegisterStep) => prevRegisterStep - 1);
                    return null;
                }else{
                    return value;
                }
            });
        }else{
            setRegion(value);
            setRegisterStep((prevRegisterStep) => prevRegisterStep + 1)
        }
    }

    const handleComplete = () => {
        const message = i18n.translate('You have successfully registered, system manager of TOC...');
        const title = i18n.translate('Welcome to Certification Service Web');
        prompt.confirm(message, {
            title: title,
            onAction: () => {
                dispatch(setRegistrationForm({}));
                router.login();
            }
        });
    }

    return (
        <Paper className={classes.root}>
            <Box position="absolute" top={0} left={0} fullWidth fullHeight backgroundColor="black" backgroundOpacity={0.5} >
                <HomeImage />
            </Box>
            <Box className={classes.workspace}>
                <Paper className={clsx(classes.form, classes.transparent)} variant="outlined" >
                    { activeStep < 1 &&
                        <RegistrationMain step={registerStep} region={region} handleRegion={handleRegion} onNext={handleNext} />
                    }
                    { (activeStep >= 1 && region === 'domestic') &&
                        <DomesticRegistration value={value} activeStep={activeStep} onChange={handleChange} onNext={handleNext}
                                              onBack={handleBack} onComplete={handleComplete}/>
                    }
                    { (activeStep >= 1 && region === 'overseas') &&
                        <OverseasRegistration value={value} activeStep={activeStep} onChange={handleChange} onNext={handleNext}
                                              onBack={handleBack} onComplete={handleComplete}/>
                    }

                </Paper>
                <Paper className={clsx(classes.stepper, classes.transparent)} variant="outlined" >
                    { activeStep < 1 && <StartStepper registerStep={registerStep}/>}
                    { (activeStep >= 1 && region === 'domestic') && <DomesticStepper activeStep={activeStep}/>}
                    { (activeStep >= 1 && region === 'overseas') && <OverseasStepper activeStep={activeStep}/>}
                </Paper>
            </Box>
        </Paper>
    );
}

export default withExplorer(Registration);
